import PropTypes from 'prop-types';
import React from 'react';
import { Form, FormGroup } from 'react-bootstrap';
import { Field } from 'redux-form';

import FormLabel from '../../atoms/FormLabel';
import * as Validator from '../../utils/Validate';

class PasswordInputComponent extends React.Component {
  static get propTypes() {
    return {
      label: PropTypes.string,
      name: PropTypes.string,
      onChange: PropTypes.func,
      validate: PropTypes.any,
    };
  }

  constructor(props) {
    super(props);

    this.component = this.component.bind(this);
    this.isRequired = this.isRequired.bind(this);
  }

  isRequired() {
    if (this.props.validate == null) {
      return false;
    }
    return this.props.validate.indexOf(Validator.required) >= 0;
  }

  component(field) {
    return (
      <FormGroup>
        <FormLabel>{field.label}</FormLabel>
        <Form.Control
          type="password"
          isInvalid={field.meta.touched && field.meta.invalid}
          {...field.input}
        />
        {field.meta.touched && field.meta.error && (
          <Form.Control.Feedback type="invalid">
            {field.meta.error}
          </Form.Control.Feedback>
        )}
      </FormGroup>
    );
  }

  render() {
    return (
      <Field
        name={this.props.name}
        label={this.props.label}
        component={this.component}
        validate={this.props.validate}
      />
    );
  }
}

export default PasswordInputComponent;
